/**
 * This file was auto-generated by Fern from our API Definition.
 */
import { WorkbookId } from "../../commons/types/WorkbookId";
export const JobDestination = WorkbookId;
